<div class="gs-result-card" [class.gs-result-selected]="item['selectedCard']">

  <!-- Header row: logo | info | actions -->
  <div class="gs-card-header">
    <img
      [src]="item.Image"
      onError="this.src='assets/default/Custom/no-image-available.svg'"
      class="gs-card-logo"
    />

    <div class="gs-card-info">
      <div class="gs-card-title-row">
        <a class="gs-card-name" (click)="openDetail(item)">
          {{ item.itemName }}
          <mat-icon class="gs-open-icon">open_in_new</mat-icon>
        </a>
        <span class="gs-type-chip" [ngClass]="'gs-type-' + (item.itemType?.toLowerCase())">
          {{ item.itemType }}
        </span>
      </div>
      <div class="gs-card-meta">
        <span *ngIf="item.OrganizationName" class="gs-meta-chip">{{ item.OrganizationName }}</span>
        <span *ngIf="item.ProjectName" class="gs-meta-chip">{{ item.ProjectName }}</span>
        <span *ngIf="item.EnvironmentName" class="gs-meta-chip">{{ item.EnvironmentName }}</span>
      </div>
    </div>

    <div class="gs-card-actions">
      <span class="gs-score-badge" *ngIf="item.Score">{{ item.Score }}</span>
      <button mat-icon-button *ngIf="item.RenderedText" (click)="viewConfig(item)" matTooltip="View Config">
        <mat-icon style="font-size:18px;width:18px;height:18px">code</mat-icon>
      </button>
      <button mat-icon-button
        [color]="item['selectedCard'] ? 'primary' : ''"
        (click)="onCardSelect(); selectCheckbox(item)"
        matTooltip="{{ item['selectedCard'] ? 'Deselect' : 'Select for chat' }}">
        <mat-icon style="font-size:20px;width:20px;height:20px">
          {{ item['selectedCard'] ? 'check_circle' : 'radio_button_unchecked' }}
        </mat-icon>
      </button>
    </div>
  </div>

  <!-- Semantic caption -->
  <div *ngIf="messages?.length" class="gs-card-caption">
    <span [innerHTML]="messages[0]"></span>
  </div>

</div>
